export type ProductionLineKind = 'dish' | 'child' | 'contractor' | 'custom';
export type ProductionRoutingLine = {
  kind: ProductionLineKind; lineId: number; dishId: number; name: string; portions: number;
};
export type ProductionAllocation = {
  kind: ProductionLineKind; lineId: number; kitchenId: number; portions: number;
};

export function hasProductionRoutingEditPermission(permissions: string[], editPermissions: string[]) {
  const key = 'page.management.event-orders';
  return permissions.includes(key) && editPermissions.includes(key);
}

export const eventOrderProtectedEditNotice =
  'Коли для замовлення є маршрутизація або збережені кухонні роботи, метадані (контакти, ціни й собівартість, примітки замовлення, загальні відомості та послуги) можна редагувати. ' +
  'Зміна меню, кількості чи виходу, секцій, часу подачі або приміток страв, дати/часу події, місця чи складу списання потребує очищення невикористаної маршрутизації. ' +
  'Якщо кухонні роботи вже збережені, такі зміни недоступні без перепланування.';

export function validateProductionAllocations(lines: ProductionRoutingLine[], allocations: ProductionAllocation[]) {
  for (const line of lines.filter(item => item.portions > 0)) {
    const allocated = allocations
      .filter(item => item.kind === line.kind && item.lineId === line.lineId)
      .reduce((sum, item) => sum + item.portions, 0);
    if (Math.abs(allocated - line.portions) > 0.000001)
      return `Розподіліть рівно ${line.portions} порцій страви «${line.name}».`;
  }
  return null;
}
